// extracted by mini-css-extract-plugin
module.exports = {"siteseal":"layout-module--siteseal--351rN","message":"layout-module--message--3MBc5","messageContent":"layout-module--messageContent--1hxzL","close":"layout-module--close--1_9X8"};